<app-add-form
  [title]="config().title"
  [formFields]="config().formFields"
  [headerActions]="config().headerActions"
  [editMode]="editMode()"
  [viewMode]="viewMode()"
  [initialData]="combinedInitialData()"
  [loading]="loading()"
  (formAction)="onFormAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
  (imageRemoved)="onImageRemoved($event)"
  (fileChanged)="onMultiFileUpload($event)"
  (existingImagesReordered)="onExistingImagesReordered($event)"
></app-add-form>

<!-- Toast Messages -->
<p-toast></p-toast>
